/**
 * Seeded pseudo-random number generator owned by the simulation (CLAUDE.md §4.2).
 * mulberry32: 32-bit integer state, uses only Math.imul and shifts, so results are
 * bit-identical across JavaScript engines. Never use Math.random in src/sim.
 */
export class Rng {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0;
  }

  /** Next value in [0, 2^32). */
  nextUint32(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return (t ^ (t >>> 14)) >>> 0;
  }

  /** Integer in [0, maxExclusive). */
  nextInt(maxExclusive: number): number {
    if (maxExclusive <= 0)
      throw new Error(`nextInt: maxExclusive must be > 0, got ${maxExclusive}`);
    return this.nextUint32() % maxExclusive;
  }

  /** Snapshot for saving/replays. */
  getState(): number {
    return this.state;
  }
}
